export const INVITE_TEMPLATE = 'bridge_invite';
export const SIGNUP_TEMPLATE = 'bridge_sign_up';
export const LOGIN_TEMPLATE = 'login_template';
